<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="superStructPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
          <h3>Superstructure Conditions</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="valid" ref="modifySuperstructureValidation">
            <LabelSelect
              id="condRatings"
              showDurationIcon
              :tooltip="
                getHistDuration(
                  structure?.inspectionConditionHist?.supRatingDuration,
                  structure?.inspectionConditionHist?.supRatingDurationChanges,
                )
              "
              @update:modelValue="
                {
                  superstructureConditionUpdated = true;
                  conditionUpdated = true;
                  isDirty = true;
                }
              "
              label="B.C.02 Superstructure Condition Rating"
              :refTable="REFERENCE_TABLE.CONDITION_RATING"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="superStructureData.supRating"
            ></LabelSelect>

            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Superstructure Notes"
              id="textarea_superstructure"
              :inspectionCommentType="INSPECTION_COMMENTS.SUPERSTRUCTURE"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              @changesDetected="
                {
                  isDirty = true;
                }
              "
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Superstructure Notes"
              id="textarea_superstructure"
              :inspectionCommentType="INSPECTION_COMMENTS.SUPERSTRUCTURE"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              :comments="superStructureData.inspectionComments"
              :brkey="superStructureData.brkey"
              :inspectionId="superStructureData.inspectionId"
              @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SUPERSTRUCTURE)"
            />
            <LabelSelect
              id="combustible_Material_Under_Bridge"
              label="SUP.01 Combustible Material Under Bridge"
              :refTable="REFERENCE_TABLE.MATERIAL_STORED_UNDER"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="superStructureData.matStoreUnd"
              @update:modelValue="
                {
                  isDirty = true;
                }
              "
            ></LabelSelect>
            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Combustible Material Under Bridge Notes"
              id="field_Combustible_Material_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              @changesDetected="
                {
                  isDirty = true;
                }
              "
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Combustible Material Under Bridge Notes"
              id="field_Combustible_Material_Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              :comments="superStructureData.inspectionComments"
              :brkey="superStructureData.brkey"
              :inspectionId="superStructureData.inspectionId"
              @updateComment="
                (comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_COMMENTS)
              "
            />

            <LabelCheckbox
              id="newCoating"
              class="labelCheckbox"
              label="SUP.02 New Coating Since Last Inspection"
              :isEditable="isEditable"
              indent
              editIndent
              v-model="superStructureData.newPaint"
              labelXl="3"
              labelLg="4"
              labelMd="5"
              labelSm="6"
              @update:modelValue="
                {
                  isDirty = true;
                }
              "
            >
            </LabelCheckbox>
            <LabelSelect
              id="protectiveCoating"
              showDurationIcon
              :tooltip="
                getHistDuration(
                  structure?.inspectionConditionHist?.paintCondRateDuration,
                  structure?.inspectionConditionHist?.paintCondRateDurationChanges,
                )
              "
              @update:modelValue="
                {
                  protectiveCoatingUpdated = true;
                  conditionUpdated = true;
                  isDirty = true;
                }
              "
              label="SUP.03 Protective Coating Rating"
              :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="superStructureData.paintCondRate"
            ></LabelSelect>
            <LabelSelect
              id="protectiveExtentCoatings"
              showDurationIcon
              :tooltip="
                getHistDuration(
                  structure?.inspectionConditionHist?.paintExtentRateDuration,
                  structure?.inspectionConditionHist?.paintExtentRateDurationChanges,
                )
              "
              @update:modelValue="
                {
                  protectiveCoatingExtentUpdated = true;
                  conditionUpdated = true;
                  isDirty = true;
                }
              "
              label="SUP.04 Protective Coating (Extent) Rating"
              :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING_EXTENT"
              :isEditable="isEditable"
              :isRequired="isEditable"
              v-model="superStructureData.paintExtentRate"
            ></LabelSelect>
            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Protective Coating Notes"
              id="textarea_overall"
              :inspectionCommentType="INSPECTION_COMMENTS.PAINT_OVERALL"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              @changesDetected="
                {
                  isDirty = true;
                }
              "
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Protective Coating Notes"
              id="textarea_overall_superstructure"
              :inspectionCommentType="INSPECTION_COMMENTS.PAINT_OVERALL"
              :readonly="!isEditable"
              :counter="notesMaxLength"
              :maxlength="notesMaxLength"
              :comments="superStructureData.inspectionComments"
              :brkey="superStructureData.brkey"
              :inspectionId="superStructureData.inspectionId"
              @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.PAINT_OVERALL)"
            />
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />
          <h3>Superstructure Details</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col sm="6" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="6"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Total_Number_Of_Span"
                label="G.01 Total Number of Spans"
                v-model="superStructureData.totalNumberOfSpans"
              >
              </LabelText>
            </v-col>
            <v-col sm="12" md="6" lg="6">
              <LabelText
                id="txt_Skew"
                label="B.G.11 Skew"
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                v-model="superStructureData.skew"
                appendWith=" °"
                type="number"
              >
              </LabelText>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                :textStyle="'width: 70%'"
                id="txt_NBIS_Bridge_Length"
                label="B.G.01 NBIS Bridge Length"
                :isEditable="isEditable"
                v-model="superStructureData.nbisBridgeLength"
                appendWith=" ft"
                :counter="null"
                type="number"
                :maxlength="8"
                :decimalPlaces="1"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
                :rules="
                  isEditable
                    ? [
                        (value) => {
                          return lessThanValueRule(value, 999999.9);
                        },
                      ]
                    : []
                "
              >
              </LabelText>
            </v-col>
            <v-col sm="6" md="6" lg="6">
              <LabelSelect
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                id="select_Curved_bridge"
                @update:modelValue="
                  {
                    superstructureConditionUpdated = true;
                    conditionUpdated = true;
                    isDirty = true;
                  }
                "
                label="B.G.12 Curved Bridge"
                :refTable="REFERENCE_TABLE.CURVED_BRIDGE"
                :isEditable="isEditable && isCurvedBridgeEditable"
                v-model="superStructureData.curvedBridge"
              ></LabelSelect>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="3"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Maximum_Span_Length"
                label="B.G.03 Maximum Span Length"
                v-model="maxMinSpanLength.maxLength"
                appendWith=" ft"
                type="number"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                :counter="null"
                :decimalPlaces="1"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
              >
              </LabelText>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="3"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Scuppers_w/Downspouts"
                label="D.08 Scuppers w/Downspouts"
                :isEditable="isEditable"
                v-model="superStructureData.scuppersWithDownspouts"
                maxlength="2"
                type="number"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
              >
              </LabelText>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="3"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Minimum_Span_Length"
                label="B.G.04 Minimum Span Length"
                v-model="maxMinSpanLength.minLength"
                appendWith=" ft"
                type="number"
                :roundingFactor="ROUNDING_FACTOR.TENTH"
                :counter="null"
                :decimalPlaces="1"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
              >
              </LabelText>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="3"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Scuppers_w/out_Downspouts"
                label="D.09 Scuppers w/out Downspouts"
                :isEditable="isEditable"
                v-model="superStructureData.scuppersWithoutDownspouts"
                maxlength="2"
                type="number"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
              >
              </LabelText>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" sm="12" md="6" lg="6">
              <LabelText
                labelXl="6"
                labelLg="9"
                labelMd="10"
                labelSm="8"
                textXl="6"
                textLg="3"
                textMd="2"
                textSm="4"
                id="txt_Bridge_Seat_Cleaning"
                label="D.06 # of Bridge Cleaning Locations"
                :isEditable="isEditable"
                v-model="superStructureData.seatCleaning"
                maxlength="2"
                type="number"
                @update:modelValue="
                  {
                    isDirty = true;
                  }
                "
              >
              </LabelText>
            </v-col>
          </v-row>
          <LabelText
            labelXl="12"
            labelLg="12"
            labelMd="12"
            labelSm="12"
            textXl="12"
            textLg="12"
            textMd="12"
            textSm="12"
            id="txt_Bridge_Seat_Cleaning_Notes"
            label="D.07 Bridge Seat Cleaning Notes"
            :isEditable="isEditable"
            v-model="superStructureData.seatCleaningNote"
            maxlength="2000"
            type="textarea"
            counter
            persistentCounter
            @update:modelValue="
              {
                isDirty = true;
              }
            "
          >
          </LabelText>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-for="(structureUnit, index) in superStructureData.structureUnits"
        :key="structureUnit"
        :id="'expansion_structure_' + index"
        :value="index + 2"
      >
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(index + 2)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(index + 2)" icon="fa-solid fa-minus" />
          <SuperstructureSpanPanelHeader :strUnitKey="structureUnit.strUnitKey" />
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-lazy :min-height="39" :options="{ threshold: 0.1 }">
            <div v-if="structureUnit.strUnitKey === -1" class="text-center text-gray-500 py-4">
              <v-label class="noRecordsMessage d-flex justify-center"
                >This structure currently contains no structure unit details.
              </v-label>
            </div>
            <SuperstructureSpanPanelText v-else :strUnitKey="structureUnit.strUnitKey" :moduleType="moduleType" />
          </v-lazy>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
import { ref, computed, onMounted, nextTick } from "vue";
import { useInspectionStore } from "@/stores/inspection";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { getHistDuration } from "@/composables/util";
import { getMaxMinSpanLength } from "@/composables/spanBySpan";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar.js";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { storeToRefs } from "pinia";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import SuperstructureSpanPanelHeader from "./superstructureComponents/superstructureSpanPanelHeader.vue";
import SuperstructureSpanPanelText from "./superstructureComponents/superstructureSpanPanelText.vue";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";
import { useNstmDetailsStore } from "@/components/inspection/store/nstmFatigueDetails";
import { lessThanValueRule } from "@/composables/validationRules";

export default {
  name: "InspectionSuperStructure",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    let valid = ref(true);
    let modifySuperstructureValidation = ref(null);
    async function validate() {
      await modifySuperstructureValidation.value.validate();
    }
    const configStore = useConfigStore();
    const inspectionStore = useInspectionStore();
    const store = useSuperstructureStore();
    const { isDirty, isEditable, isCurvedBridgeEditable, panel, superStructureData, brkey, locations } =
      storeToRefs(store);
    const { toggleAllPanels, fetchData } = store;
    let structure = computed(() => inspectionStore.selectedInspection);
    let nstmFatigueDetailStore = useNstmDetailsStore();

    const notesMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    const inspectionId = computed(() => {
      return superStructureData.value.inspectionId;
    });

    const loadNstmData = () => {
      nextTick(() => {
        nstmFatigueDetailStore.setNstmFatigueValue({
          brkey: brkey.value,
          inspectionFCs: superStructureData.value.inspectionFCs,
          locations: locations.value,
          inspectionId: inspectionId.value,
        });
      });
    };
    let superstructureConditionUpdated = ref(false);
    let protectiveCoatingUpdated = ref(false);
    let protectiveCoatingExtentUpdated = ref(false);
    let conditionUpdated = ref(false);
    const updateDuration = () => {
      if (!structure.value.inspectionConditionHist) {
        structure.value.inspectionConditionHist = {};
      }
      if (superstructureConditionUpdated.value) {
        structure.value.inspectionConditionHist.supRatingDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.supRatingDurationChanges,
        );
        structure.value.inspectionConditionHist.supRatingDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.supRatingDuration,
          structure.value.inspectionConditionHist.supRatingDurationChanges,
        );
      }
      if (protectiveCoatingUpdated.value) {
        structure.value.inspectionConditionHist.paintCondRateDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.paintCondRateDurationChanges,
        );
        structure.value.inspectionConditionHist.paintCondRateDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.paintCondRateDuration,
          structure.value.inspectionConditionHist.paintCondRateDurationChanges,
        );
      }

      if (protectiveCoatingExtentUpdated.value) {
        structure.value.inspectionConditionHist.paintExtentRateDurationChanges = inspectionStore.setDurationChanges(
          structure.value.inspectionConditionHist.paintExtentRateDurationChanges,
        );
        structure.value.inspectionConditionHist.paintExtentRateDuration = inspectionStore.setDuration(
          structure.value.inspectionConditionHist.paintExtentRateDuration,
          structure.value.inspectionConditionHist.paintExtentRateDurationChanges,
        );
      }

      superstructureConditionUpdated.value = false;
      protectiveCoatingUpdated.value = false;
      protectiveCoatingExtentUpdated.value = false;
      conditionUpdated.value = false;
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Superstructure-Screen", marker: SNACKBAR_MARKER.BEARINGS };
    };

    const maxMinSpanLength = computed(() => {
      return getMaxMinSpanLength(superStructureData.value.structureUnits, ["M", "A", "W"]);
    });

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = superStructureData.value.inspectionComments.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
        foundComment.updateUserId = comment.updateUserId;
        foundComment.updateDateTime = comment.updateDateTime;
      } else {
        superStructureData.value.inspectionComments.push(comment);
      }
      isDirty.value = true;
    };

    const readData = async () => {
      await fetchData(props.moduleType);
      loadNstmData();
      await validate();
    };

    const saveChanges = async () => {
      if (!valid.value) {
        inspectionStore.setShowValidationSnackbar(true);
      }
      inspectionStore.setShowValidationSnackbar(false);
      const structure = inspectionStore.selectedInspection;
      const isSuccess = await store.saveSuperstructure(props.moduleType, superStructureData.value, structure);
      if (isSuccess) {
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          inspectionStore.setLowestConditionRating();
        }
        await readData();
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      await readData();
    };

    onMounted(async () => {
      await readData();
    });

    return {
      maxMinSpanLength,
      conditionUpdated,
      protectiveCoatingExtentUpdated,
      protectiveCoatingUpdated,
      updateDuration,
      superstructureConditionUpdated,
      panel,
      isDirty,
      isEditable,
      isCurvedBridgeEditable,
      notesMaxLength,
      getHistDuration,
      INSPECTION_COMMENTS,
      REFERENCE_TABLE,
      valid,
      modifySuperstructureValidation,
      toggleAllPanels,
      printD491,
      inspectionStore,
      validate,
      structure,
      setUpdatedComment,
      superStructureData,
      readData,
      saveChanges,
      cancelChanges,
      MODULE_TYPES,
      ROUNDING_FACTOR,
      lessThanValueRule,
    };
  },
  components: {
    CommentTypeTextField,
    LabelSelect,
    LabelText,
    LabelCheckbox,
    ExpandCollapseToggle,
    ManagementCommentTypeTextField,
    SuperstructureSpanPanelHeader,
    SuperstructureSpanPanelText,
    ValidationCountsHeader,
  },
};
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  color: c.$p-white !important;
}
</style>
